import { render, staticRenderFns } from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=template&id=72d1cb96&scoped=true&"
import script from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=script&lang=js&"
export * from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=style&index=0&id=72d1cb96&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1cb96",
  null
  
)

export default component.exports